import React from "react";
import PropTypes from "prop-types";
import Button from "../../components/button.js";
import { GlobalDispatchContext } from "../../context/global-context-provider";
import { parsePrice, updateDataLayer } from "../../utils/helpers";
import { _ } from "../../utils/i18n";

const ProductButton = ({
  product,
  className,
  currency,
  priceDecimalSeparator,
  priceThousandSeparator,
  isVariation,
}) => {
  const dispatch = React.useContext(GlobalDispatchContext);

  const onButtonClick = () => {
    dispatch({
      type: "ADD_TO_CART",
      value: {
        name: product.name,
        priceRaw:
          product.price &&
          parsePrice(
            product.price,
            priceThousandSeparator,
            priceDecimalSeparator
          ),
        price: product.price,
        quantity: 1,
        id: product.databaseId,
        image: product.image,
        uri: product.uri,
        currency: currency,
        sku: product.sku ?? "",
        salePrice: product.salePrice,
        regularPrice: product.regularPrice,
        onSale: product.onSale,
      },
    });

    updateDataLayer(async () =>
      window.dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          currency: currency,
          value: product?.priceRaw,
          items: [
            {
              item_id: product?.databaseId,
              item_name: product?.name,
              item_category: product?.productCategories?.nodes?.[0]?.name,
              item_brand: product?.productBrands?.nodes?.[0]?.name,
              price: product?.priceRaw,
              quantity: 1,
            },
          ],
        },
      })
    );
  };

  return isVariation ? (
    <Button innerClassName={className} to={product.uri}>
      {_("Velg alternativ")}
    </Button>
  ) : (
    <Button innerClassName={className} onClick={onButtonClick}>
      {_("Legg i handlekurv")}
    </Button>
  );
};

ProductButton.propTypes = {
  product: PropTypes.shape({
    price: PropTypes.string,
    priceRaw: PropTypes.number,
    name: PropTypes.string,
    image: PropTypes.object,
    databaseId: PropTypes.number,
    uri: PropTypes.string,
    sku: PropTypes.string,
    salePrice: PropTypes.string,
    regularPrice: PropTypes.string,
    onSale: PropTypes.bool,
    productCategories: PropTypes.object,
    productBrands: PropTypes.object,
  }),
  className: PropTypes.string,
  currency: PropTypes.string,
  priceDecimalSeparator: PropTypes.string,
  priceThousandSeparator: PropTypes.string,
  isVariation: PropTypes.bool,
};

export default ProductButton;
